import { render, staticRenderFns } from "./PoliticalContributionForm.vue?vue&type=template&id=c983f392&scoped=true"
import script from "./PoliticalContributionForm.vue?vue&type=script&lang=js"
export * from "./PoliticalContributionForm.vue?vue&type=script&lang=js"
import style0 from "./PoliticalContributionForm.vue?vue&type=style&index=0&id=c983f392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c983f392",
  null
  
)

export default component.exports